<template>
  <!--begin::Wrapper-->

  <div
    class="w-lg-425px bg-primary p-10 p-lg-15 mx-auto d-flex flex-column justify-content-center h-100 align-items-center bg-white shadow-lg div-login-panel"
  >
    <div class="w-100 d-flex justify-content-end mb-12">
      <a
        href="#"
        @click="setLang('en')"
        class="rounded h-30px w-30px me-2"
        :style="i18n.locale.value == 'en' ? 'border: rgba(255, 255, 255, 0.6) solid 1px;' : 'border:0px'"
      >
        <img
          class="rounded-1 m-1"
          src="media/flags/en.svg"
          alt="metronic"
        />
      </a>
      <a
        href="#"
        @click="setLang('tr')"
        class="rounded h-30px w-30px"
        :style="i18n.locale.value == 'tr' ? 'border: rgba(255, 255, 255, 0.6) solid 1px;' : 'border: 0px'"
      >
        <img
          class="rounded-1 m-1"
          src="media/flags/tr.svg"
          alt="metronic"
        />
      </a>
    </div>
    <div class="text-center mb-10">
      <img
        alt="Logo"
        src="/media/svg/files/white_logo.svg"
        class="h-52px w-200px"
      />
    </div>

    <Form
      ref="refForm"
      class="form w-100 form-login mb-10"
      id="kt_login_signin_form"
      @submit="onSubmitLogin"
      :validation-schema="loginValidation"
    >
      <div class="fv-row mb-7">
        <div class="form-floating mb-1">
          <div class="fv-plugins-message-container d-v-content">
            <div class="fv-help-block v-element">
              <ErrorMessage name="email" />
            </div>
          </div>
          <Field
            class="form-control text-gray-800"
            id="floatingInput"
            placeholder="name@example.com"
            type="text"
            name="email"
            autocomplete="off"
            v-model="email"
          />
          <label
            for="floatingInput"
            class="fs-6 text-gray-800"
            >{{ translate("EMail") }}</label
          >
        </div>
      </div>

      <div class="fv-row mb-10">
        <div class="form-floating mb-7">
          <div class="fv-plugins-message-container d-v-content">
            <div class="fv-help-block v-element">
              <ErrorMessage name="password" />
            </div>
          </div>
          <Field
            type="password"
            class="form-control text-gray-800"
            id="floatingPassword"
            placeholder="Password"
            name="password"
            v-model="password"
            @keydown.enter="onSubmitLogin"
          />
          <label
            for="floatingPassword"
            class="fs-6 text-gray-800"
            >{{ translate("user_detail_public_label_password") }}</label
          >
        </div>

        <div class="form-check form-check-custom form-check-solid">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="check-remember"
            v-model="remember"
            style="border: 0.1em solid #fff !important"
          />
          <label
            class="form-check-label text-white"
            for="check-remember"
          >
            {{ translate("RememberMe") }}
          </label>
        </div>
      </div>

      <div class="d-flex flex-column align-items-end">
        <button
          id="kt_sign_in_submit"
          class="btn btn-lg btn-white text-primary w-50 mb-2"
          :disabled="loading"
          type="submit"
        >
          <div
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
          ></div>
          <span> {{ translate("signIn") }}</span>
        </button>

        <span class="text-white">
          {{ translate("register_login_text") }}

          <router-link to="/sign-up">
            <a
              class="text-white"
              style="text-decoration: underline"
              >{{ translate("register_login_link") }}</a
            ></router-link
          >
        </span>
      </div>
    </Form>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useCookies } from "vue3-cookies";
import { useI18n } from "vue-i18n";
import * as Yup from "yup";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
const toast = useToast();

const { cookies } = useCookies();
const store = useStore();
const router = useRouter();
const email = ref("");
const password = ref("");
const remember = ref(false);
const loading = ref(false);

//Multi Language
const { t, te } = useI18n();
const i18n = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const onConfirm = () => {
  toast.removeGroup("bc");
};
const onReject = () => {
  toast.removeGroup("bc");
};

const loginValidation = Yup.object().shape({
  email: Yup.string().nullable().required(translate("user_modal_validation_email")),
  password: Yup.string().nullable().required(translate("user_modal_validation_password")),
});

//Form submit function
const onSubmitLogin = () => {
  loading.value = true;
  if (remember.value) {
    let object = { email: email.value, password: password.value };
    cookies.set("remember", JSON.stringify(object), "30D");
  } else {
    cookies.remove("remember");
  }
  store
    .dispatch("AuthModule/GET_LOGİN", {
      email: email.value,
      password: password.value,
    })
    .then((res) => {
      if (res.Success) {
        router.push({ name: "dashboard" });
        loading.value = false;
      } else {
        loading.value = false;
      }
    });
};

const setLang = (lang) => {
  localStorage.setItem("lang", lang);
  i18n.locale.value = lang;
};

onMounted(() => {
  let obj = cookies.get("remember") !== undefined ? cookies.get("remember") : "";
  if (obj !== null) {
    email.value = obj.email;
    password.value = obj.password;
    remember.value = true;
  }
});
</script>
<style scoped>
@media screen and (max-width: 992px) {
  .div-login-panel {
    width: 100% !important;
  }
  .form-login {
    width: 500px !important;
  }
}
</style>
